import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Shield } from "lucide-react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import TenantRoleForm from "src/components/forms/TenantRoleForm";

import { useAppSelector } from "src/redux/hooks";

const CreateEditRolePage: React.FC = () => {
  const basePath = "/app/team-management";
  const navigate = useNavigate();
  const { tenantRoleId } = useParams();
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  const isTenantAdmin =
    user?.role === "admin" ||
    user?.roleDetails?.name?.toLowerCase() === "admin";

  if (!isTenantAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <DashboardLayout
      meta={{
        title: `${tenantRoleId ? "Edit" : "Add"} Designation | Invyntra`,
        description: "Manage designations and their permissions.",
      }}
    >
      <div className="space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <Shield size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              {tenantRoleId ? "Edit Designation" : "Add Designation"}
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Define what this role can view, create, edit, and delete across
              the app.
            </p>
          </div>
        </div>

        <Card>
          <TenantRoleForm
            tenantRoleId={tenantRoleId}
            onCancel={() => navigate(`${basePath}/role-list`)}
            onSuccess={() => navigate(`${basePath}/role-list`)}
          />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default CreateEditRolePage;
